import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Box from '../box/box.esm.js';

var Article = /*#__PURE__*/React.forwardRef(function Article(props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: "article"
  }, props));
});

export default Article;
//# sourceMappingURL=article.esm.js.map
